import {Component, OnInit, ViewChild} from '@angular/core';
import {Response} from '@angular/http';
import {Router} from '@angular/router';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Tiplist} from 'shared/models/tips/tiplist';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {TipListOverviewService} from './services/tip-list-overview.service';

@Component({
  selector: 'tip-list-overview',
  templateUrl: './tip-list-overview.component.html',
  styleUrls: ['./tip-list-overview.component.css'],
})

export class TipListOverviewComponent {

  public tiplists: Array<Tiplist> = [];
  public filteredTiplists: Array<Tiplist> = [];
  public fieldsToSearch: Array<Array<string>> = [];
  public currentPage: Event;

  @ViewChild('deleteModal') public deleteModal: ModalConfirmationComponent;

  constructor(private tiplistOverviewService: TipListOverviewService,
              private router: Router) { }

  public ngOnInit(): void {
    this.tiplistOverviewService.getTiplists()
      .subscribe((tiplists: Array<Tiplist>) => {
        this.tiplists = tiplists;
        this.filteredTiplists = tiplists;
        this.prepareFieldsToSearch();
      });
  }

  public showDeleteModal(tiplistId: string): void {
    const tiplistTitle: string = this.getTiplistById(tiplistId).title;
    const content: string = `Sind Sie sicher, dass Sie die Tipliste "${tiplistTitle}" löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(tiplistId)
      .show();
  }

  public editTiplist(tiplistId: string): void {
    this.router.navigate(['tiplist', 'details', {tiplistId: tiplistId}]);
  }

  public createTiplist(): void {
    this.router.navigate(['tiplist', 'details']);
  }

  public deleteTiplist(id: string): void {
    this.tiplistOverviewService.deleteTiplist(id)
      .subscribe((deleteResponse: Response) => {
        const index: number = this.tiplists.findIndex((tiplist: Tiplist) => {
          return tiplist._id === id;
        });

        if (index > -1) {
          this.tiplists.splice(index, 1);
        }
      });
  }

  public filterTiplists(eventTiplist: Array<Tiplist>): void {
    this.filteredTiplists = eventTiplist;
  }

  private prepareFieldsToSearch(): void {
    this.tiplists.forEach((tiplist) => {
      this.fieldsToSearch.push([
        tiplist.title.toLowerCase(),
        tiplist.description.toLowerCase(),
      ]);
    });
  }

  private getTiplistById(id: string): Tiplist {
    return this.tiplists.find((tiplist) => {
      return tiplist._id === id;
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-overview/tip-list-overview.component.ts